@if (this.control()) {

  <div class="flex gap-2">
    <div class="flex h-10 shrink-0 items-center">
      <elcia-check-box [control]="this.control().controls.isDone"/>
    </div>
    <div class="w-5/8">
      <elcia-text-input [control]="this.control().controls.title" [label]="'sub-todo.title' | translate"/>
    </div>
    <div class="w-2/8">
      <elcia-user-dropdown [control]="this.control().controls.assignedToId" [isMulti]="false" [label]="'assigned'"/>
    </div>
    <div class="w-1/8">
      <elcia-date-picker [control]="this.control().controls.dueDate" [label]="'sub-todo.due-date' | translate"/>
    </div>

    <div>
      @if (this.control().controls.title.value) {
        <elcia-button (onClick)="this.remove()" [icon]="'minus'" [severity]="'secondary'"/>
      }
    </div>
  </div>
}
